export interface MangaCategory {
  id: string;
  name: string;
  icon: string;
  count: number;
  desc: string;
}

export interface MangaItem {
  id: string;
  title: string;
  subtitle: string;
  cover: string;
  category: string;
  tags: string[];
  status: '连载中' | '已完结';
  latestChapter: string;
  views: number;
  rating: number;
  year: string;
  desc: string;
}

export const mangaCategories: MangaCategory[] = [
  { id: 'all', name: '全部', icon: 'ri-command-line', count: 1826, desc: '全站书库' },
  { id: 'rexue', name: '热血', icon: 'ri-flashlight-fill', count: 286, desc: '燃向打斗与伙伴情义' },
  { id: 'xuanhuan', name: '玄幻', icon: 'ri-star-fill', count: 314, desc: '仙侠修真与异界大陆' },
  { id: 'dushi', name: '都市', icon: 'ri-building-2-fill', count: 208, desc: '都市商战与生活流' },
  { id: 'xanyi', name: '悬疑', icon: 'ri-eye-2-fill', count: 176, desc: '烧脑推理与诡局' },
  { id: 'kehuan', name: '科幻', icon: 'ri-rocket-2-fill', count: 152, desc: '硬核科幻与末世' },
  { id: 'lianai', name: '恋爱', icon: 'ri-heart-3-fill', count: 241, desc: '纯爱日常与心动' },
  { id: 'gaoxiao', name: '搞笑', icon: 'ri-emotion-laugh-fill', count: 168, desc: '无厘头欢乐日常' },
  { id: 'zhiyu', name: '治愈', icon: 'ri-sun-foggy-fill', count: 131, desc: '暖心故事与和解' },
  { id: 'maoxian', name: '冒险', icon: 'ri-compass-3-fill', count: 150, desc: '探索未知世界' },
];

export const mangaList: MangaItem[] = [
  {
    id: 'm01',
    title: '星火燃烬录',
    subtitle: '燃向热血 · 少年觉醒',
    cover: 'https://readdy.ai/api/search-image?query=vibrant%20manga%20comic%20book%20cover%20art%2C%20young%20boy%20igniting%20flames%20in%20both%20fists%2C%20dynamic%20action%20pose%2C%20bold%20ink%20linework%2C%20coral%20red%20fire%20with%20amber%20sparks%2C%20dark%20night%20city%20background%2C%20dramatic%20cinematic%20lighting%2C%20high%20detail%2C%20clean%20composition%2C%20energy%20trails%20and%20speed%20lines&width=600&height=900&seq=cover-m01&orientation=portrait',
    category: '热血',
    tags: ['少年', '燃向', '异能'],
    status: '连载中',
    latestChapter: '第 216 话',
    views: 986000,
    rating: 9.4,
    year: '2024',
    desc: '十六岁的少年苏燃在觉醒日那天点燃了沉寂百年的星火之力，从此踏上与伙伴并肩、燃烧命运的冒险之路。',
  },
  {
    id: 'm02',
    title: '墨色黎明',
    subtitle: '悬疑推理 · 高能反转',
    cover: 'https://readdy.ai/api/search-image?query=dark%20manga%20comic%20book%20cover%20art%2C%20detective%20in%20long%20black%20coat%20standing%20under%20moonlight%2C%20mysterious%20fog%20and%20city%20silhouette%2C%20ink%20wash%20style%2C%20deep%20indigo%20and%20silver%20tones%2C%20cinematic%20contrast%2C%20dramatic%20shadows%2C%20high%20detail%2C%20clean%20composition&width=600&height=900&seq=cover-m02&orientation=portrait',
    category: '悬疑',
    tags: ['推理', '烧脑', '单元剧'],
    status: '连载中',
    latestChapter: '第 88 话',
    views: 642000,
    rating: 9.1,
    year: '2023',
    desc: '以"永夜"之名行走都市的神秘侦探，在一次次高能反转的诡局中逼近十年前的真相。',
  },
  {
    id: 'm03',
    title: '少年与不夜城',
    subtitle: '都市异能 · 热血群像',
    cover: 'https://readdy.ai/api/search-image?query=energetic%20manga%20comic%20book%20cover%20art%2C%20group%20of%20teenagers%20running%20through%20neon%20city%20street%20at%20night%2C%20colorful%20neon%20lights%2C%20dynamic%20camera%20angle%2C%20bold%20linework%2C%20purple%20and%20cyan%20glow%2C%20cinematic%20motion%2C%20high%20detail%2C%20energetic%20composition&width=600&height=900&seq=cover-m03&orientation=portrait',
    category: '都市',
    tags: ['群像', '都市', '异能'],
    status: '连载中',
    latestChapter: '第 132 话',
    views: 725000,
    rating: 8.8,
    year: '2024',
    desc: '一座永不熄灭的不夜城，一群拥有异能的少年，在霓虹与黑暗交织的街头写下自己的传说。',
  },
  {
    id: 'm04',
    title: '万古青莲',
    subtitle: '玄幻修真 · 仙侠巨制',
    cover: 'https://readdy.ai/api/search-image?query=epic%20manga%20comic%20book%20cover%20art%2C%20xianxia%20cultivator%20standing%20on%20floating%20lotus%20over%20misty%20mountain%2C%20glowing%20cyan%20energy%2C%20golden%20aureole%20behind%2C%20oriental%20ink%20painting%20style%2C%20flowing%20robes%2C%20dramatic%20clouds%2C%20high%20detail%2C%20ethereal%20lighting%2C%20clean%20composition&width=600&height=900&seq=cover-m04&orientation=portrait',
    category: '玄幻',
    tags: ['修真', '仙侠', '逆袭'],
    status: '已完结',
    latestChapter: '第 480 话',
    views: 1120000,
    rating: 9.6,
    year: '2022',
    desc: '废柴少年一朝觉醒上古青莲圣体，从灵溪镇一路崛起，踏破万古，问鼎仙途巅峰。',
  },
  {
    id: 'm05',
    title: '第七舰队',
    subtitle: '科幻战争 · 硬核太空',
    cover: 'https://readdy.ai/api/search-image?query=hard%20sci-fi%20manga%20comic%20book%20cover%20art%2C%20massive%20spaceship%20fleet%20battling%20in%20deep%20space%2C%20commander%20in%20military%20uniform%20in%20foreground%2C%20laser%20exchanges%2C%20dark%20space%20background%20with%20stars%2C%20blue%20and%20orange%20thruster%20glow%2C%20mecha%20detail%2C%20dramatic%20scale%2C%20high%20detail%2C%20clean%20composition&width=600&height=900&seq=cover-m05&orientation=portrait',
    category: '科幻',
    tags: ['太空', '战争', '机甲'],
    status: '连载中',
    latestChapter: '第 64 话',
    views: 398000,
    rating: 8.9,
    year: '2025',
    desc: '人类文明迈向深空，第七舰队在星海间为家园而战。热血与牺牲并存的硬核太空战争物语。',
  },
  {
    id: 'm06',
    title: '心动信号',
    subtitle: '青春恋爱 · 甜蜜日常',
    cover: 'https://readdy.ai/api/search-image?query=sweet%20romance%20manga%20comic%20book%20cover%20art%2C%20two%20high%20school%20students%20under%20cherry%20blossom%20tree%2C%20soft%20pastel%20pink%20and%20warm%20yellow%20lighting%2C%20gentle%20smiles%2C%20clean%20shojo%20style%2C%20sparkles%20and%20petals%20floating%2C%20delicate%20linework%2C%20romantic%20atmosphere%2C%20high%20detail%2C%20clean%20background&width=600&height=900&seq=cover-m06&orientation=portrait',
    category: '恋爱',
    tags: ['纯爱', '校园', '日常'],
    status: '连载中',
    latestChapter: '第 96 话',
    views: 886000,
    rating: 9.2,
    year: '2023',
    desc: '一次偶然的邻座相遇，让两颗青涩的心逐渐靠近。细腻又心动的校园纯爱物语。',
  },
  {
    id: 'm07',
    title: '星际快递员',
    subtitle: '搞笑科幻 · 无厘头日常',
    cover: 'https://readdy.ai/api/search-image?query=funny%20manga%20comic%20book%20cover%20art%2C%20cute%20alien%20delivery%20boy%20flying%20space%20scooter%20holding%20parcel%2C%20goofy%20expression%2C%20colorful%20galaxy%20background%2C%20bright%20saturated%20colors%2C%20cartoon%20comedy%20style%2C%20playful%20energy%2C%20bold%20outline%2C%20high%20detail%2C%20cheerful%20composition&width=600&height=900&seq=cover-m07&orientation=portrait',
    category: '搞笑',
    tags: ['科幻', '搞笑', '单元剧'],
    status: '连载中',
    latestChapter: '第 210 话',
    views: 578000,
    rating: 8.7,
    year: '2024',
    desc: '在银河系最繁忙的快递公司打工的小哥，每天都要把包裹送到各种离谱的星球上去。',
  },
  {
    id: 'm08',
    title: '云端书店',
    subtitle: '治愈系 · 温暖故事',
    cover: 'https://readdy.ai/api/search-image?query=healing%20manga%20comic%20book%20cover%20art%2C%20cozy%20bookstore%20floating%20in%20soft%20clouds%2C%20warm%20reading%20lamp%20glow%2C%20shelves%20of%20books%2C%20little%20girl%20reading%20by%20window%2C%20gentle%20pastel%20cream%20and%20amber%20tones%2C%20soft%20lighting%2C%20peaceful%20atmosphere%2C%20delicate%20detail%2C%20clean%20composition%2C%20wholesome%20and%20calm&width=600&height=900&seq=cover-m08&orientation=portrait',
    category: '治愈',
    tags: ['温暖', '治愈', '轻漫'],
    status: '已完结',
    latestChapter: '第 120 话',
    views: 436000,
    rating: 9.3,
    year: '2022',
    desc: '开在云端的小小书店，收藏着每一个治愈人心的故事。读一页，世界就安静了下来。',
  },
  {
    id: 'm09',
    title: '深渊回响',
    subtitle: '恐怖惊悚 · 极致氛围',
    cover: 'https://readdy.ai/api/search-image?query=horror%20manga%20comic%20book%20cover%20art%2C%20lonely%20figure%20facing%20dark%20abyss%20with%20glowing%20eyes%20in%20darkness%2C%20eerie%20red%20glow%2C%20grainy%20ink%20style%2C%20deep%20black%20shadows%2C%20distorted%20silhouette%2C%20chilling%20atmosphere%2C%20high%20contrast%2C%20dramatic%20fog%2C%20high%20detail%2C%20clean%20composition&width=600&height=900&seq=cover-m09&orientation=portrait',
    category: '悬疑',
    tags: ['恐怖', '惊悚', '悬疑'],
    status: '连载中',
    latestChapter: '第 52 话',
    views: 315000,
    rating: 8.5,
    year: '2025',
    desc: '每一个坠入深渊的灵魂都会留下回响。深夜故事，胆小的读者请结伴而行。',
  },
  {
    id: 'm10',
    title: '元气小厨娘',
    subtitle: '美食治愈 · 轻松日常',
    cover: 'https://readdy.ai/api/search-image?query=cute%20manga%20comic%20book%20cover%20art%2C%20energetic%20chef%20girl%20holding%20steaming%20bowl%20of%20noodles%2C%20kitchen%20background%20with%20appetizing%20food%2C%20bright%20warm%20yellow%20and%20orange%20lighting%2C%20cheerful%20expression%2C%20clean%20cartoon%20style%2C%20steam%20and%20sparkles%2C%20appetizing%20colors%2C%20high%20detail%2C%20wholesome%20composition&width=600&height=900&seq=cover-m10&orientation=portrait',
    category: '治愈',
    tags: ['美食', '日常', '温馨'],
    status: '已完结',
    latestChapter: '第 150 话',
    views: 523000,
    rating: 8.9,
    year: '2023',
    desc: '经营着街角小馆的元气小厨娘，用一道道暖胃料理治愈着每个疲惫的食客。',
  },
  {
    id: 'm11',
    title: '逆命者',
    subtitle: '玄幻热血 · 反套路逆袭',
    cover: 'https://readdy.ai/api/search-image?query=epic%20manga%20comic%20book%20cover%20art%2C%20determined%20young%20warrior%20holding%20giant%20blade%20standing%20against%20raging%20storm%2C%20lightning%20striking%20behind%2C%20deep%20red%20cape%20flowing%2C%20dark%20stormy%20sky%2C%20dramatic%20backlight%2C%20bold%20linework%2C%20cinematic%20intensity%2C%20high%20detail%2C%20heroic%20composition&width=600&height=900&seq=cover-m11&orientation=portrait',
    category: '热血',
    tags: ['逆袭', '玄幻', '战斗'],
    status: '连载中',
    latestChapter: '第 176 话',
    views: 812000,
    rating: 9.0,
    year: '2023',
    desc: '出身微末却心向苍穹的少年，手持逆命之刃，一次次斩破宿命的枷锁。',
  },
  {
    id: 'm12',
    title: '侦探事务所',
    subtitle: '悬疑单元剧 · 高能推理',
    cover: 'https://readdy.ai/api/search-image?query=mystery%20manga%20comic%20book%20cover%20art%2C%20sleek%20detective%20office%20at%20night%2C%20two%20detectives%20examining%20case%20board%20with%20photos%20and%20strings%2C%20single%20desk%20lamp%20glow%2C%20moody%20brown%20and%20amber%20tones%2C%20noir%20atmosphere%2C%20ink%20shading%2C%20mysterious%20shadows%2C%20high%20detail%2C%20clean%20composition&width=600&height=900&seq=cover-m12&orientation=portrait',
    category: '悬疑',
    tags: ['推理', '单元剧', '烧脑'],
    status: '已完结',
    latestChapter: '第 198 话',
    views: 467000,
    rating: 9.1,
    year: '2021',
    desc: '一个不起眼的侦探事务所，破解着一桩桩看似无解的谜案。真相往往藏在最深处。',
  },
  {
    id: 'm13',
    title: '机甲少女',
    subtitle: '科幻萌燃 · 机甲战斗',
    cover: 'https://readdy.ai/api/search-image?query=mecha%20manga%20comic%20book%20cover%20art%2C%20girl%20in%20white%20pilot%20suit%20standing%20beside%20giant%20colorful%20mecha%20robot%2C%20industrial%20hangar%20background%2C%20cool%20cyan%20and%20coral%20accents%2C%20dynamic%20pose%2C%20tech%20detail%20panels%2C%20bold%20outline%2C%20high%20detail%2C%20clean%20composition%2C%20exciting%20atmosphere&width=600&height=900&seq=cover-m13&orientation=portrait',
    category: '科幻',
    tags: ['机甲', '萌系', '战斗'],
    status: '连载中',
    latestChapter: '第 74 话',
    views: 689000,
    rating: 8.8,
    year: '2024',
    desc: '为守护家园而战的少女，与她独一无二的机甲伙伴并肩出击。萌点与燃点并存。',
  },
  {
    id: 'm14',
    title: '朝暮之间',
    subtitle: '都市恋爱 · 治愈纯爱',
    cover: 'https://readdy.ai/api/search-image?query=romantic%20manga%20comic%20book%20cover%20art%2C%20young%20couple%20watching%20sunset%20from%20rooftop%2C%20warm%20golden%20hour%20glow%2C%20soft%20city%20skyline%20behind%2C%20gentle%20shoji%20style%2C%20warm%20orange%20and%20cream%20tones%2C%20tender%20atmosphere%2C%20delicate%20linework%2C%20high%20detail%2C%20clean%20composition&width=600&height=900&seq=cover-m14&orientation=portrait',
    category: '恋爱',
    tags: ['纯爱', '都市', '治愈'],
    status: '连载中',
    latestChapter: '第 58 话',
    views: 392000,
    rating: 9.0,
    year: '2025',
    desc: '在一座快节奏的城市里，两个慢下来的人相遇了。朝与暮之间，藏着所有心动。',
  },
  {
    id: 'm15',
    title: '山海异闻录',
    subtitle: '玄幻冒险 · 上古异兽',
    cover: 'https://readdy.ai/api/search-image?query=adventure%20manga%20comic%20book%20cover%20art%2C%20explorer%20girl%20riding%20mythical%20beast%20through%20misty%20mountains%2C%20ancient%20chinese%20style%2C%20emerald%20and%20gold%20tones%2C%20legendary%20creatures%2C%20rolling%20clouds%2C%20oriental%20ink%20aesthetic%2C%20grand%20scale%2C%20dramatic%20lighting%2C%20high%20detail%2C%20clean%20composition&width=600&height=900&seq=cover-m15&orientation=portrait',
    category: '冒险',
    tags: ['异兽', '冒险', '古风'],
    status: '已完结',
    latestChapter: '第 260 话',
    views: 701000,
    rating: 9.2,
    year: '2022',
    desc: '少女踏遍山海，结识上古异兽，解锁一部尘封的异闻录。古风冒险的极致浪漫。',
  },
  {
    id: 'm16',
    title: '篮球之魂',
    subtitle: '运动热血 · 青春燃烧',
    cover: 'https://readdy.ai/api/search-image?query=sports%20manga%20comic%20book%20cover%20art%2C%20basketball%20player%20leaping%20for%20dunk%20in%20full%20gym%2C%20dynamic%20motion%20blur%2C%20sweat%20and%20determination%2C%20orange%20and%20deep%20blue%20lighting%2C%20crowd%20cheering%20in%20background%2C%20action%20pose%2C%20bold%20linework%2C%20high%20detail%2C%20energetic%20composition%2C%20inspiring%20atmosphere&width=600&height=900&seq=cover-m16&orientation=portrait',
    category: '热血',
    tags: ['运动', '青春', '竞技'],
    status: '连载中',
    latestChapter: '第 142 话',
    views: 934000,
    rating: 9.3,
    year: '2024',
    desc: '一支不被看好的高中篮球队，为了一次冠军梦想拼尽全力的青春物语。',
  },
  {
    id: 'm17',
    title: '指尖恋人',
    subtitle: '恋爱日常 · 甜蜜爆表',
    cover: 'https://readdy.ai/api/search-image?query=adorable%20manga%20comic%20book%20cover%20art%2C%20couple%20sharing%20earbuds%20listening%20music%20in%20park%2C%20pink%20and%20lilac%20blossoms%2C%20soft%20daylight%2C%20blush%20cheeks%2C%20clean%20shojo%20style%2C%20sparkles%2C%20sweet%20romance%20mood%2C%20delicate%20details%2C%20high%20detail%2C%20clean%20background&width=600&height=900&seq=cover-m17&orientation=portrait',
    category: '恋爱',
    tags: ['纯爱', '日常', '校园'],
    status: '已完结',
    latestChapter: '第 108 话',
    views: 589000,
    rating: 8.9,
    year: '2023',
    desc: '从共享一副耳机开始的心动日常，甜度拉满的恋爱轻喜剧。',
  },
  {
    id: 'm18',
    title: '废土行者',
    subtitle: '末世科幻 · 生存冒险',
    cover: 'https://readdy.ai/api/search-image?query=post-apocalyptic%20manga%20comic%20book%20cover%20art%2C%20lone%20survivor%20with%20scarf%20walking%20through%20ruined%20city%20with%20dust%20storm%2C%20rust%20orange%20and%20brown%20palette%2C%20muted%20cinematic%20lighting%2C%20gritty%20texture%2C%20survival%20atmosphere%2C%20sweeping%20ruins%20background%2C%20high%20detail%2C%20moody%20composition%2C%20epic%20scale&width=600&height=900&seq=cover-m18&orientation=portrait',
    category: '科幻',
    tags: ['末世', '生存', '冒险'],
    status: '连载中',
    latestChapter: '第 45 话',
    views: 287000,
    rating: 8.6,
    year: '2025',
    desc: '文明崩塌后的废土之上，一个孤独行者穿行于废墟之间，寻找最后一片绿洲。',
  },
];

export function formatViews(n: number): string {
  if (n >= 1000000) return `${(n / 1000000).toFixed(1)}万`;
  if (n >= 10000) return `${(n / 10000).toFixed(1)}万`;
  return `${n}`;
}